import { Box, Center, Flex, HStack, Icon, Text, Link, useColorModeValue as mode } from '@chakra-ui/react'
import * as React from 'react'

type NavActionProps = {
  href?: string
  label: string
  icon: React.ElementType
  isActive?: boolean
  children?: React.ReactNode
  handleClick?: () => void
}

const MobileNavAction = (props: NavActionProps) => {
  const { label, icon, isActive, href, children } = props
  return (
    <Center
      as="a"
      href={href}
      height="56px"
      rounded="4"
      aria-current={isActive ? 'page' : undefined}
      _activeLink={{ color: mode('blue.500', 'blue.300') }}
      _hover={{ bg: mode('gray.100', 'gray.700') }}
    >
      <Flex position="relative" direction="column" align="center" as="button">
        <Box fontSize="xl" as={icon} />
        <Text fontSize="sm" fontWeight="medium">
          {label}
        </Text>
        {children}
      </Flex>
    </Center>
  )
}

const DesktopNavAction = (props: NavActionProps) => {
  const { label, icon, href } = props
  return (
    <HStack spacing="2" as="a" >
      <Link fontSize="sm" href={href} color="gray.800" fontWeight="medium">
        {label}
      </Link>
      <Icon as={icon} />
    </HStack>
  )
}

export const NavAction = {
  Mobile: MobileNavAction,
  Desktop: DesktopNavAction,
}